/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import DragZoneUpload from 'components/DragZoneUpload';
import FormContainer from 'components/FormContainer';
import FormSection from 'components/FormSection';
import HasPermission from 'components/HasPermission/index';
import Icon from 'components/Icon';
import { ModalCancelEndorsement, ModalEditConfirmation, ModalLost } from 'components/index';
import Layout from 'components/Layout';
import Loader from 'components/Loader';
import NotesAccordion from 'components/NotesAccordion';
import StepNavigation from 'components/StepNavigation';
import TagsList from 'components/TagList';
import Access from 'constants/Access';
import Colors from 'constants/Colors';
import { Form, Formik } from 'formik';
import { camelCase, uniqueId } from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GlobalAuthContext, GlobalLoaderContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';
import FunctionHelpers from "utils/src/function-helpers";
import * as yup from 'yup';
import { AddButton, ButtonContent } from './styles';

const functionHelpers = new FunctionHelpers;

export default function EditEnquirity(props) {
  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef();
  const location = useLocation();
  const handleBack = () => history.goBack();
  const isClient = authContext.enumProfile === 1 ? true : false;
  let refOperation = null;
  let createWithReference = null;

  // Usado para desabilitar os campos, pois usando o state não pega o valor correto do Bound
  let isBound = false;

  const [isMasterPolicy, setIsMasterPolicy] = useState(false)
  const [hasPermissionCreateFramework, setHasPermissionCreateFramework] = useState(false);
  const [questionnaire, setQuestionnaire] = useState([]);
  const [riskQuestionnaire, setRiskQuestionnaire] = useState([]);
  const [brokingQuestionnaire, setBrokingQuestionnaire] = useState([]);
  const [obligors, setObligors] = useState([]);
  const [guarantors, setGuarantors] = useState([]);
  const [borrowers, setBorrowers] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [operation, setOperation] = useState({});
  const [removedRiskQuestionnaire, setRemovedRiskQuestionnaire] = useState([]);
  const [currentClient, setCurrentClient] = useState(null);
  const [modalEditConfirmationDialogOpen, setModalEditConfirmationDialogOpen] = useState(false);
  const [modalLostDialogOpen, setModalLostDialogOpen] = useState(false);
  const [modalCancelEndorsementOpen, setModalCancelEndorsementOpen] = useState({ visible: false });
  const [permissionAccess, setPermissionAccess] = useState(false);
  const [toggleIsActived, setToggleIsActived] = useState(false);

  const changeStateDefaultOfToggle = (state) => {
    setToggleIsActived(state);
  }

  // Usado para renderizar o componente haspermission
  const [isBoundState, setIsBoundState] = useState(false);

  const SECTIONS = {
    SUMMARY: { name: 'SUMMARY', isMultiple: false, isRisk: false },
    BROKING: { name: 'BROKING', isMultiple: false, isRisk: false },
    OBLIGOR: { name: 'OBLIGOR', isMultiple: true, isRisk: false },
    GUARANTOR: { name: 'GUARANTOR', isMultiple: true, isRisk: false },
    BORROWER: { name: 'BORROWER', isMultiple: true, isRisk: false },
    FACILITY: { name: 'FACILITY', isMultiple: true, isRisk: true },
    ATTACHMENT: { name: 'ATTACHMENT', isMultiple: false, isRisk: false },
    ATTACHMENT_NOTES: { name: 'ATTACHMENT_NOTES', isMultiple: false, isRisk: false },
  };

  const OPERATION_MAP = {
    26: {
      12: {
        title: `${props.match.params.idOperation ? 'Edit' : 'Create'} Enquiry`,
        nextPage: '/enquiries',
        voidButtonTitle: 'Lost'
      },
      16: {
        title: `${props.match.params.idOperation ? 'Edit' : 'Create'} Enquiry - ${isMasterPolicy ? 'Framework' : 'Declaration'}`,
        nextPage: isMasterPolicy ? `/broking/select-markets/${props.match.params.idOperation}/${props.match.params.idProduct}` : '/enquiries',
        voidButtonTitle: 'Lost'
      }
    },
    254: {
      12: {
        title: `Adjustment & Corrections`,
        nextPage: `/broking/adjustments-and-corrections-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      36: {
        title: `Adjustment & Corrections`,
        nextPage: `/broking/adjustments-and-corrections-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      47: {
        title: `Adjustment & Corrections`,
        nextPage: `/broking/adjustments-and-corrections-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      26: {
        title: `Adjustment & Corrections`,
        nextPage: `/broking/adjustments-and-corrections-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      16: {
        title: `Adjustment & Corrections`,
        nextPage: `/broking/adjustments-and-corrections-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      }
    },
    410: {
      12: {
        title: `Risk & Market Changes`,
        nextPage: `/broking/market-composition/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      36: {
        title: `Risk & Market Changes`,
        nextPage: `/broking/market-composition/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      47: {
        title: `Risk & Market Changes`,
        nextPage: `/broking/market-composition/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      26: {
        title: `Risk & Market Changes`,
        nextPage: `/broking/market-composition/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      16: {
        title: `Risk & Market Changes`,
        nextPage: `/broking/market-composition/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      }
    },
    624: {
      12: {
        title: `Client Change`,
        nextPage: `/broking/client-change-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      36: {
        title: `Client Change`,
        nextPage: `/broking/client-change-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      47: {
        title: `Client Change`,
        nextPage: `/broking/client-change-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      26: {
        title: `Client Change`,
        nextPage: `/broking/client-change-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      },
      16: {
        title: `Client Change`,
        nextPage: `/broking/client-change-edit/${props.match.params.idOperation}`,
        voidButtonTitle: 'Cancel'
      }
    },
  }

  async function permissionEdit() {
    const response = await fitinsur
      .requestAccess("", "READ", Access.PERSON_EDIT, null, props.match?.params?.idOperation, authContext.token)
      .then((response) => response.json())

    const hasPermissionRead = response && response.ret_code === 200;

    const responseCreate = await fitinsur
      .requestAccess("", "CREATE", Access.PERSON_EDIT, null, props.match?.params?.idOperation, authContext.token)
      .then((response) => response.json())

    const hasPermissionCreate = responseCreate && responseCreate.ret_code === 200;

    const responseUpdate = await fitinsur
      .requestAccess("", "UPDATE", Access.PERSON_EDIT, null, props.match?.params?.idOperation, authContext.token)
      .then((response) => response.json())

    const hasPermissionUpdate = responseUpdate && responseUpdate.ret_code === 200;

    setPermissionAccess(hasPermissionRead || hasPermissionCreate || hasPermissionUpdate);
  }

  const operationMap = OPERATION_MAP[operation.idDomain] || {};

  const getQuestionUniqueKey = (question, index) => {
    if (question.idQuestion === 112) return `${camelCase(question.dsQuestion)}`;

    const key = `${camelCase(question.dsQuestion)}${index != null ? `_${index}` : ""}_${uniqueId()}`;
    formikRef.current?.setFieldValue(key, question.behaviorObject?.defaultValue || "");
    return key;
  };

  const getQuestionIsDisabled = (question, operation) => {
    if (refOperation && !createWithReference) return true;
    if (isBound) return true;

    if (isMasterPolicy && !hasPermissionCreateFramework) return true;
    if (operation && operation.idDomainStatus === 2) return true;
    if (!operation || (operation.idDomain === 26 && !operation.idDomainDocument)) return false;
    if (operation.idDomainStatus === 2 || operation.idDomainStatus === 5 || operation.idDomainStatus === 187 || operation.idDomainStatus === 402 || operation.idDomainStatus === 197) return true;
    if (operation.idDomain !== 26 && operation.idDomain !== 254 && operation.idDomain !== 624 && operation.idDomain !== 410) return true;

    const disabledFieldsByOperation = {
      26: [59, 61, 113, 121, 831],
      254: [121, 76, 59, 116, 123, 128, 67, 68, 69, 70, 71, 72, 73, 74, 75, 129, 130, 184, 126, 72, 78, 119],
      410: [59, 121, 76],
      624: [27, 61, 63, 64, 66, 67, 68, 69, 70, 71, 72, 72, 73, 74, 75, 76, 78, 113, 114, 116,119, 120, 121, 122, 123, 124, 126, 127, 128, 129, 130, 182, 183, 184, 282, 283, 284, 286, 330, 754, 755, 831, 2001]
    }

    let disabledFilesds = disabledFieldsByOperation[operation.idDomain];
    return disabledFilesds && disabledFilesds.includes(question.idQuestion) && !createWithReference;
  }

  const disableButton = (operation) => {
    if (isClient && operation?.idOperation && operation?.idDomain !== 254 && operation.idDomain !== 624) return false;

    if (isClient && operation.idDomain !== 26) return true;
    if (isClient && operation.idDomainStatus && operation.idDomainStatus !== 1 && operation.idDomainStatus !== 8) return true;
    if (isClient && operation.idDomainStatusDocument) return true;
  }

  const getQuoteQuestionnaire = async (checkIsMasterPolicy = false) => {
    loading.start();

    fitinsur.setAuthToken(authContext.token);
    let response = await fitinsur.requestEditDocuments(refOperation || props.match.params.idOperation)
      .then(x => x.json());

    setAttachments(response.ret_value?.map(v => ({ ...v, ...v.file })));

    fitinsur.setAuthToken(authContext.token);
    response = await fitinsur.requestProductsList().then(v => v.json())
    if (response.ret_code != 200) return;
    let product = response.ret_value.find(v => +v.ID_PRODUCT === +props.match.params.idProduct);

    fitinsur.setAuthToken(authContext.token);
    if (props.match.params.idOperation) {
      response = await fitinsur.requestQuoteEdit(props.match.params.idProduct, refOperation || props.match.params.idOperation, 26)
        .then(x => x.json());
    } else if (refOperation) {
      response = await fitinsur.requestQuoteEdit(props.match.params.idProduct, refOperation, 26)
        .then(x => x.json());

      createWithReference = true;
      setAttachments([]);
    } else {
      response = await fitinsur.requestQuoteAdd(props.match.params.idProduct, 26)
        .then(x => x.json());
    }

    await handleOperationInfo();

    try {
      if (response.ret_code != 200) {
        mc.error(response.ret_msg_details);
        loading.stop();
        return;
      }

      const retOperation = !createWithReference ? response.ret_value.operation : null;

      const groupMultipleFieldQuestions = (mainIdQuestion, otherIdQuestions, questionnaire) => {
        const groupQuestions = [];

        const mainQuestions = questionnaire.filter(question => question.idQuestion === mainIdQuestion);
        for (const mainQuestion of mainQuestions) {
          const group = []
          const mainQuestionIndex = questionnaire.findIndex(question => question.idQuestion === mainIdQuestion);
          if (mainQuestionIndex) group.push(questionnaire[mainQuestionIndex]);
          if (mainQuestionIndex != -1) questionnaire.splice(mainQuestionIndex, 1);

          for (const otherIdQuestion of otherIdQuestions) {
            const otherIdQuestionIndex = questionnaire.findIndex(question => question.idQuestion === otherIdQuestion);
            if (otherIdQuestionIndex != -1) group.push(questionnaire[otherIdQuestionIndex]);
            if (otherIdQuestionIndex != -1) questionnaire.splice(otherIdQuestionIndex, 1);
          }
          group.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
          groupQuestions.push(group.map((question, index) => ({ ...question, key: question.key || getQuestionUniqueKey(question, index), disabled: getQuestionIsDisabled(question, retOperation) })));
        }

        return groupQuestions;
      }

      let questionnaire = []
      questionnaire = [...questionnaire, ...response.ret_value.persons];
      questionnaire = [...questionnaire, ...response.ret_value.operations];
      questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
      if (product) questionnaire = questionnaire.map(v => v.idQuestion === 121 ? ({ ...v, answer: product.PRODUCT_NAME, answerJson: undefined }) : v);

      const obligor = groupMultipleFieldQuestions(63, [114, 64, 282], questionnaire)
      const guarantor = groupMultipleFieldQuestions(66, [27, 284], questionnaire)
      const borrower = groupMultipleFieldQuestions(120, [127, 286], questionnaire)

      //special tratment / insured legal entity
      const insuredLegalEntities = questionnaire.filter(question => question.idQuestion === 60)
      let riskQuestionnaire = []
      if (response.ret_value.riskQuestionnaires) {
        response.ret_value.riskQuestionnaires.map((riskGroup, index) => {
          const { risks } = riskGroup;
          if (insuredLegalEntities[index]) risks.push(insuredLegalEntities[index]);
          riskQuestionnaire.push(risks.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion).map((question, index) => ({ ...question, key: getQuestionUniqueKey(question, index), disabled: getQuestionIsDisabled(question, retOperation) })));
        });
      } else if (response.ret_value.risks) {
        const { risks } = response.ret_value || []
        if (insuredLegalEntities[0] && risks.length) risks.push(insuredLegalEntities[0]);
        riskQuestionnaire.push(risks.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion).map((question, index) => ({ ...question, key: getQuestionUniqueKey(question, index), disabled: getQuestionIsDisabled(question, retOperation) })))
      }

      questionnaire = questionnaire.filter(question => question.idQuestion !== 60)
      questionnaire = questionnaire
        .map((question, index) => ({
          ...question,
          key: getQuestionUniqueKey(question, index),
          disabled: getQuestionIsDisabled(question, retOperation)
        }))
        .filter(v => (!props.match.params.idOperation && !checkIsMasterPolicy) || (props.match.params.idOperation && !retOperation?.isMasterPolicy)
          ? true
          : (v.idQuestion !== 182 && v.idQuestion !== 183
          ))

      questionnaire = questionnaire.map(question => {
        if (createWithReference)
          delete question.idQuestionnaireAnswers

        if (question.idQuestion === 2001) {
          return {
            ...question,
            visibleQuestion: 1,
            behaviorObject: {
              ...question.behaviorObject,
              isRequired: false
            },
          }
        } else if ((props.match.params.idProduct == 36 || props.match.params.idProduct == 47) && question.idQuestion === 122) {
          return {
            ...question,
            visibleQuestion: 0,
            behaviorObject: {
              ...question.behaviorObject,
              isRequired: false
            },
          }
        }
        if (question.idQuestion === 831) {
          if (!question.answer && !question.answerJson) {
            return {
              ...question,
              answerJson: functionHelpers.formatDate(retOperation?.operationDate ? new Date(retOperation?.operationDate) : new Date()),
              answer: functionHelpers.formatDate(retOperation?.operationDate ? new Date(retOperation?.operationDate) : new Date()),
              disable: false
            }
          }
        }
        return { ...question }
      });

      setObligors(obligor);
      setGuarantors(guarantor);
      setBorrowers(borrower);
      setQuestionnaire(questionnaire);
      setRiskQuestionnaire(riskQuestionnaire);
      setOperation(retOperation || { idDomain: 26 });
      if (retOperation) setIsMasterPolicy(retOperation.isMasterPolicy)
      loading.stop();
    } catch (e) {
      loading.stop();
    }
  }

  const getSicCodeFromObligor = async (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    try {

      if (question && question.idQuestion === 63) {
        const countryOfRiskQuestion = filteredQuestionnaire.find(v => v.idQuestion === 64);
        setFieldValue && setFieldValue(countryOfRiskQuestion.key, "");

        let { idPerson, id } = answer || {};
        if (!idPerson && !id) throw new Error('Sic coding not found!');
        idPerson = idPerson || id;

        loading.start();
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur.requestSicCode(idPerson).then(v => v.json());
        const { ret_code, ret_value } = response;

        if (ret_value.descSic) {
          const sicCodeQuestion = filteredQuestionnaire.find(v => v.idQuestion === 114);
          filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === sicCodeQuestion.key ? ({ ...v, disabled: true, idAnswerOption: null, answer: ret_value.descSic, answerJson: undefined }) : v)
          setFieldValue && setFieldValue(sicCodeQuestion.key, ret_value.descSic);
        }

        if (ret_value.descCountryOfRisk) {
          filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === countryOfRiskQuestion.key ? ({ ...v, disabled: true, idAnswerOption: null, answer: ret_value.descCountryOfRisk, answerJson: undefined }) : v)
          setFieldValue && setFieldValue(countryOfRiskQuestion.key, ret_value.descCountryOfRisk);
        }

      }

      if (question && question.idQuestion === 66) {
        const countryOfRiskQuestionParty1 = filteredQuestionnaire.find(v => v.idQuestion === 27);
        setFieldValue && setFieldValue(countryOfRiskQuestionParty1.key, "");

        let { idPerson, id } = answer || {};
        if (!idPerson && !id) throw new Error('Sic coding not found!');
        idPerson = idPerson || id;

        loading.start();
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur.requestSicCode(idPerson).then(v => v.json());
        const { ret_code, ret_value } = response;
        if (!ret_value || !ret_value.descCountryOfRisk) throw new Error('Country of risk not found!');

        if (ret_value.descCountryOfRisk) {
          filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === countryOfRiskQuestionParty1.key ? ({ ...v, disabled: true, idAnswerOption: null, answer: ret_value.descCountryOfRisk, answerJson: undefined }) : v)
          setFieldValue && setFieldValue(countryOfRiskQuestionParty1.key, ret_value.descCountryOfRisk);
        }
      }

      if (question && question.idQuestion === 120) {
        const countryOfRiskQuestionParty2 = filteredQuestionnaire.find(v => v.idQuestion === 127);
        setFieldValue && setFieldValue(countryOfRiskQuestionParty2.key, "");

        let { idPerson, id } = answer || {};
        if (!idPerson && !id) throw new Error('Sic coding not found!');
        idPerson = idPerson || id;

        loading.start();
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur.requestSicCode(idPerson).then(v => v.json());
        const { ret_code, ret_value } = response;

        if (ret_value.descCountryOfRisk) {
          filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === countryOfRiskQuestionParty2.key ? ({ ...v, disabled: true, idAnswerOption: null, answer: ret_value.descCountryOfRisk, answerJson: undefined }) : v)
          setFieldValue && setFieldValue(countryOfRiskQuestionParty2.key, ret_value.descCountryOfRisk);
        }
      }
      setFilteredQuestionnaire(filteredQuestionnaire)
    } catch (e) {
      if (question.idQuestion === 63) {
        const sicCodeQuestion = filteredQuestionnaire.find(v => v.idQuestion === 114);
        filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === sicCodeQuestion.key ? ({ ...v, disabled: false, idAnswerOption: null, answer: "", answerJson: undefined }) : v)
        setFieldValue && setFieldValue(sicCodeQuestion.key, "");
      }
      if (question.idQuestion === 66) {
        const countryOfRiskQuestionParty1 = filteredQuestionnaire.find(v => v.idQuestion === 27);
        filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === countryOfRiskQuestionParty1.key ? ({ ...v, disabled: false, idAnswerOption: null, answer: "", answerJson: undefined }) : v)
        setFieldValue && setFieldValue(countryOfRiskQuestionParty1.key, "");
      }
      if (question.idQuestion === 120) {
        const countryOfRiskQuestionParty2 = filteredQuestionnaire.find(v => v.idQuestion === 127);
        filteredQuestionnaire = filteredQuestionnaire.map(v => v.key === countryOfRiskQuestionParty2.key ? ({ ...v, disabled: false, idAnswerOption: null, answer: "", answerJson: undefined }) : v)
        setFieldValue && setFieldValue(countryOfRiskQuestionParty2.key, "");
      }

      setFilteredQuestionnaire(filteredQuestionnaire)
      return loading.stop();
    }

    return loading.stop();
  }

  const buildValidation = () => {
    const validationSchema = {};


    for (const question of questionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
      if (!isClient && question.key !== "leadingOffice_9_39") {
        validationSchema[question.key] = question.behaviorObject?.isRequired && question.visibleQuestion
          ? yup.string().required("* Required field")
          : yup.string().notRequired().nullable();
      } else if (isClient && question.key !== "leadingOffice_9_39") {
        validationSchema[question.key] = yup.string().notRequired();
      }
    }

    for (const question of brokingQuestionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
      if (!isClient && question.key !== "leadingOffice_9_39") {
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
          ? yup.string().required("* Required field")
          : yup.string().notRequired();
      } else if (isClient && question.key !== "leadingOffice_9_39") {
        validationSchema[question.key] = yup.string().notRequired();
      } else if (question.idQuestion === 2001) {
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
          ? yup.string().required("* Required field")
          : yup.string().notRequired();
      }
    }

    if (isMasterPolicy) return yup.object().shape(validationSchema)

    for (const [index, obligor] of obligors.entries()) {
      for (const question of obligor) {
        if (!question.key) continue;
        if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required("* Required field") : yup.string().notRequired();
      }
    }

    for (const [index, borrower] of borrowers.entries()) {
      for (const question of borrower) {
        if (!question.key) continue;
        if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required("* Required field") : yup.string().notRequired()
        if (question.idQuestion === 127) {
          const borrowerQuestion = borrower.find(v => v.idQuestion === 120);
          if (borrowerQuestion) {
            validationSchema[question.key] = yup.string().when(borrowerQuestion.key, (borrower, borrowerCountry) => !borrower ? borrowerCountry : borrowerCountry.required('* Required field'))
          }
        }

        if (question.idQuestion === 286) {
          const borrowerQuestion = borrower.find(v => v.idQuestion === 120);
          if (borrowerQuestion) {
            validationSchema[question.key] = yup.string().when(borrowerQuestion.key, (borrower, borrowerTypeOfParty) => !borrower ? borrowerTypeOfParty : borrowerTypeOfParty.required('* Required field'))
          }
        }
      }
    }

    for (const [index, guarantor] of guarantors.entries()) {
      for (const question of guarantor) {
        if (!question.key) continue;
        if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required("* Required field") : yup.string().notRequired();
        if (question.idQuestion === 27) {
          const guarantorQuestion = guarantor.find(v => v.idQuestion === 66);
          if (guarantorQuestion) {
            validationSchema[question.key] = yup.string().when(guarantorQuestion.key, (guarantor, guarantorCountry) => !guarantor ? guarantorCountry : guarantorCountry.required('* Required field'));
          }
        }

        if (question.idQuestion === 284) {
          const guarantorQuestion = guarantor.find(v => v.idQuestion === 66);
          if (guarantorQuestion) {
            validationSchema[question.key] = yup.string().when(guarantorQuestion.key, (guarantor, guarantorTypeOfParty) => !guarantor ? guarantorTypeOfParty : guarantorTypeOfParty.required('* Required field'));
          }
        }
      }
    }

    for (const [index, risk] of riskQuestionnaire.entries()) {
      for (const question of risk) {
        if (!question.key) continue;
        if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;
        if (!toggleIsActived) {
          validationSchema[question.key] = yup.string().notRequired();
          continue;
        }
        
        validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired ? yup.string().required("* Required field") : yup.string().notRequired();
        //grossInsuredParticipation
        if (question.idQuestion === 70) {
          const totalFacilityAmountQuestion = risk.find(v => v.idQuestion === 69);
          if (totalFacilityAmountQuestion) {
            validationSchema[question.key] = yup.mixed().required('* Required field').when(totalFacilityAmountQuestion.key, (totalFacility, grossInsured) => grossInsured.test("more than", "* Must be lower or equal than Total Facility Amount", gross => Number(gross?.replaceAll(",", "").replaceAll(".", "")) <= Number(totalFacility?.replaceAll(",", "").replaceAll(".", ""))));
          }
        }

        //Max Limit of Liability:
        if (question.idQuestion === 71) {
          const grossInsuredParticipationQuestion = risk.find(v => v.idQuestion === 70);
          if (grossInsuredParticipationQuestion) {
            validationSchema[question.key] = yup.mixed().required('* Required field').when(grossInsuredParticipationQuestion.key, (grossInsured, maxLimit) => maxLimit.test("more than", "* Must be lower or equal than Gross Insured Participation", max => Number(max?.replaceAll(",", "").replaceAll(".", "")) <= Number(grossInsured?.replaceAll(",", "").replaceAll(".", ""))))
          }
        }

        //Max Limit of Liability:
        if (question.idQuestion === 75) {
          const grossLoanMarginQuestion = risk.find(v => v.idQuestion === 74);
          if (grossLoanMarginQuestion) {
            validationSchema[question.key] = yup.mixed().when(grossLoanMarginQuestion.key, (grossLoan, netLoan) => netLoan.test("more than", "* Must be lower or equal than Gross Loan Margin", net => net?.length >= 1 ? !Number(grossLoan?.split("%")[1] || 0) || Number(net?.split("%")[1]) <= Number(grossLoan?.split("%")[1]) : true))
          }
        }
      }
    }

    return yup.object().shape(validationSchema)
  }

  const removeAnswersDuplicateSession = (questions, index, partySectionName, values) => {
    questions = JSON.parse(JSON.stringify(questions));
    return questions.map(question => {
      const { defaultValue } = question.behaviorObject || {};
      if (partySectionName) {
        if (question.idQuestion === 282 || question.idQuestion === 284 || question.idQuestion === 286) {
          const partyAnswers = values[partySectionName];
          if (partyAnswers) {
            const typeOfPartyAnswer = partyAnswers.find(v => v.idQuestion === question.idQuestion);
            if (typeOfPartyAnswer) {
              question.answer = typeOfPartyAnswer.answer;
              question.answerJson = typeOfPartyAnswer.answerJson;
              question.idAnswerOption = typeOfPartyAnswer.idAnswerOption;
            }
          }
        } else {
          question.answer = defaultValue;
          question.answerJson = defaultValue;
        }
      } else if (question.idQuestion !== 60) {
        question.answer = defaultValue;
        question.answerJson = defaultValue;
      }

      if (question.idQuestion !== 282 && question.idQuestion !== 284 && question.idQuestion !== 286) {
        question.idAnswerOption = null;
      }

      question.idPerson = null;
      question.idQuestionnaireAnswers = null;
      question.key = null;
      question.key = getQuestionUniqueKey(question, index)
      return question;
    })
  }

  const handleSaveEnquiry = async (values) => {
    values = JSON.parse(JSON.stringify(values));
    try {
      loading.start();

      let body = {
        isMasterPolicy,
        create: !props.match.params.idOperation,
        idTemplate: 1,
        idDomainStatus: operation?.idDomainStatus || null,
        idProduct: props.match.params.idProduct,
        idOperation: props.match.params.idOperation,
        idOperationParent: props.match.params.idOperationParent,
        idDomainOperation: 26,
        idDomainTypeOperation: 9,
        persons: [],
        operationsQuestionnaire: [],
        riskQuestionnaire: {
          groupings: []
        },
        deleteds: removedRiskQuestionnaire,
        attachments: []
      }

      for (const [key, section] of Object.entries(SECTIONS)) {
        if (section.isRisk) {
          riskQuestionnaire.map((riskAnswers, index) => {
            let sectionAnswers = values[`$ANSWERS_${section.name}_${index}`];
            if (section.name === 'FACILITY' && sectionAnswers) {
              sectionAnswers = sectionAnswers.map(item => {
                if (item.idQuestion === 68 && item.answer?.length > 3) {
                  item.answer = JSON.parse(item.answer).value;
                  item.answerJson = item.answer;
                }
                return { ...item }
              });
            }
            if (sectionAnswers) {
              const risk = { idOperation: body.idOperation, risks: sectionAnswers }
              body.riskQuestionnaire.groupings.push(risk);
            }
          })
        } if (section.isMultiple) {
          const multipleFields = section.name === 'OBLIGOR' ? obligors : section.name === 'BORROWER' ? borrowers : section.name === 'GUARANTOR' ? guarantors : [];
          multipleFields.map((field, index) => {
            let sectionAnswers = values[`$ANSWERS_${section.name}_${index}`];
            if (sectionAnswers) {
              body.persons = [...body.persons, ...sectionAnswers];
            }
          })
        } else {
          let sectionAnswers = values[`$ANSWERS_${section.name}`];
          if (sectionAnswers) {
            body.persons = [...body.persons, ...sectionAnswers.filter(question => question.idQuestionnaire === 8)];
            body.operationsQuestionnaire = [...body.operationsQuestionnaire, ...sectionAnswers.filter(question => question.idQuestionnaire === 10)];
          }
        }
      }


      const getQuestionOtherFields = (question, idQuestionOtherField, questionnaire) => {
        if (!question.otherFields) question.otherFields = [];
        const otherFieldQuestionnaireIndex = questionnaire.findIndex(question => question.idQuestion === idQuestionOtherField);
        if (otherFieldQuestionnaireIndex != -1) question.otherFields.push(questionnaire[otherFieldQuestionnaireIndex]);
        if (otherFieldQuestionnaireIndex != -1) questionnaire.splice(otherFieldQuestionnaireIndex, 1);
      }

      //exclusive treatments
      //client
      const client = body.persons.find(question => question.idQuestion === 59);
      if (client) {
        getQuestionOtherFields(client, 121, body.operationsQuestionnaire);
        getQuestionOtherFields(client, 76, body.operationsQuestionnaire);
        getQuestionOtherFields(client, 113, body.persons);
        getQuestionOtherFields(client, 122, body.operationsQuestionnaire);

        const internalContactIndex = body.persons.findIndex(question => question.idQuestion === 61);
        const internalContact = body.persons[internalContactIndex];
        if (internalContact && internalContact.answer && internalContact.answer.trim().length) {
          client.contact = {
            idDomainContact: 282,
            answer: internalContact.answer,
            idQuestionnaire: internalContact.idQuestionnaire,
            idQuestion: internalContact.idQuestion,
            idQuestionnaireAnswers: internalContact.idQuestionnaireAnswers,
            idContact: internalContact.idContact
          }
          body.persons.splice(internalContactIndex, 1);
        }
      }

      const mainPartyTypes = [...new Set(body.persons.filter(v => v.idQuestion === 282).map(v => v.answer))];
      const additionalPartyITypes = [...new Set(body.persons.filter(v => v.idQuestion === 284).map(v => v.answer))];
      const additionalPartyIITypes = [...new Set(body.persons.filter(v => v.idQuestion === 286).map(v => v.answer))];

      if (mainPartyTypes.length > 1) {
        mc.error("Main party types should be the same");
        loading.stop();
        return;
      }

      if (additionalPartyITypes.length > 1 || additionalPartyIITypes.length > 1) {
        mc.error("Additional Party types should be the same");
        loading.stop();
        return;
      }

      //obligor
      const obligorsAnswers = body.persons.filter(question => question.idQuestion === 63);
      for (const obligor of obligorsAnswers) {
        getQuestionOtherFields(obligor, 114, body.persons);
        getQuestionOtherFields(obligor, 64, body.persons);
        getQuestionOtherFields(obligor, 282, body.persons);
      }

      //guarantor
      const guarantorsAnswers = body.persons.filter(question => question.idQuestion === 66);
      for (const guarantor of guarantorsAnswers) {
        getQuestionOtherFields(guarantor, 27, body.persons);
        getQuestionOtherFields(guarantor, 284, body.persons);
      }

      //borrower
      const borrowersAnswers = body.persons.filter(question => question.idQuestion === 120);
      for (const borrower of borrowersAnswers) {
        getQuestionOtherFields(borrower, 127, body.persons);
        getQuestionOtherFields(borrower, 286, body.persons);
      }

      //build attachment body
      const attachmentQuestion = questionnaire.find(question => question.idQuestion === 78);
      body.attachments = attachments.map(attachment => ({
        ...attachment,
        fileBase64: undefined,
        idQuestion: attachmentQuestion?.idQuestion,
        idQuestionnaire: attachmentQuestion?.idQuestionnaire,
        idDocument: attachment?.idDocument,
        idQuestionnaireAnswers: attachment?.idQuestionnaireAnswers,
      }))

      const facilityNames = [];
      let minimumRetainedFlag = false;
      body.riskQuestionnaire.groupings.map(group => {
        const minimumRetained = group.risks.find(v => v.idQuestion === 129);
        const facilityName = group.risks.find(v => v.idQuestion === 123);
        const grossLoanMargin = group.risks.find(v => v.idQuestion === 74);
        const netLoanMargin = group.risks.find(v => v.idQuestion === 75);
        const commitmentFee = group.risks.find(v => v.idQuestion === 184);

        if (minimumRetained && minimumRetained.answer) {
          minimumRetained.answer = minimumRetained.answer.trim()
          if (minimumRetained.answer == "%") {
            minimumRetainedFlag = true
            return;
          }
        }

        if (facilityName && facilityName.answer) {
          facilityName.answer = facilityName.answer.trim()
        }

        if (facilityName) facilityNames.push(facilityName.answer);

        if (grossLoanMargin && (!grossLoanMargin.answer || !String(grossLoanMargin.answer).trim().length)) {
          grossLoanMargin.answer = "0"
        }

        if (netLoanMargin && (!netLoanMargin.answer || !String(netLoanMargin.answer).trim().length)) {
          netLoanMargin.answer = "0"
        }

        if (commitmentFee && (!commitmentFee.answer || !String(commitmentFee.answer).trim().length)) {
          commitmentFee.answer = "0"
        }
      })

      if (minimumRetainedFlag) {
        mc.error(`Minimum retained percentage should be filled`);
        loading.stop();
        return;
      }

      if (toggleIsActived) {
        if (facilityNames.some(v => !v || !v.trim().length || !v.replace(/\s/g, '').length)) {
          mc.error(`Facility name should be filled`);
          loading.stop();
          return;
        }
      }
      let nonRepeatedFacilityNames = [...new Set(facilityNames)];
      if (nonRepeatedFacilityNames.length < facilityNames.length) {
        mc.error("Facility name should be unique");
        loading.stop();
        return;
      }

      let arrayFromCharacters = [], arrayFacilitiesName = [];
      let hasThreeEqualsCharacters, arrayIsSmall;

      if (!props.match.params.idOperation || operation?.idDomain == 26) {
        facilityNames.map((facilityName) => {
          if (facilityName) {
            facilityName = facilityName.trim();
            hasThreeEqualsCharacters = /(.)\1\1/.test(facilityName) && facilityName.length == 3;
            arrayIsSmall = facilityName.length < 3;
            if (arrayIsSmall) {
              arrayFacilitiesName.push(facilityName);
            }
            if (hasThreeEqualsCharacters) {
              arrayFromCharacters.push(facilityName);
            }
          }
        })
      }

      if (arrayFacilitiesName.length >= 1) {
        mc.error("Facility name should contain at least 3 characters");
        loading.stop();
        return;
      }

      if (arrayFromCharacters.length >= 1) {
        mc.error("Facility name should not have 3 equal consecutive characters");
        loading.stop();
        return;
      }

      let response = null;

      fitinsur.setAuthToken(authContext.token);
      response = await fitinsur.requestQuoteSubmit(body).then(v => v.json())
      if (response.ret_code != 200) {
        loading.stop();
        return mc.error(response.ret_msg_details);
      }

      loading.stop();

      if (!isMasterPolicy && operation.idDomainDocument && operation?.idDomain === 26 && toggleIsActived) {
        return setModalEditConfirmationDialogOpen(true);
      }

      if (response.isMigratedMarketChanges) {
        return handleCreateMarketChangeQuotation()
      }

      if (isMasterPolicy) return history.push(`/broking/select-markets/${response.ret_value}/${props.match.params.idProduct}`, { idProduct: props.match.params.idProduct });

      history.push(operationMap[props.match.params.idProduct]?.nextPage || '/enquiries', { idProduct: props.match.params.idProduct });
    } catch (err) {
      console.log("err", err)
      loading.stop();
      mc.error("An error happened, please try again.");
    }
  }

  const handleCreateMarketChangeQuotation = () => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.createMarketChangeQuotation(props.match.params.idOperation)
      .then(data => data.json())
      .then(resp => {
        loading.stop();
        if (resp.ret_code !== 200) {
          mc.error(resp.ret_msg_details);
          return;
        }

        if (props.match.params.idProduct == 12) {
          return history.push(`/broking/select-markets/${resp?.ret_value.quotationOperationId}`, { idProduct: props.match.params.idProduct });
        } else {
          return history.push(`/broking/select-markets/${resp?.ret_value.quotationOperationId}/${props.match.params.idProduct}`, { idProduct: props.match.params.idProduct });
        }
      }).catch(e => {
        loading.stop();
      });
  }

  const handleGenerateNbiForm = async () => {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSendNbiForm(props.match.params.idOperation, 4).then(resp => {
      if (resp.status !== 200) return resp.json().then((res) => mc.error(res.ret_msg_details));
      history.push('/broking/nbi-request/' + props.match.params.idOperation, { idProduct: props.match.params.idProduct });
    }).catch((error) => {
      loading.stop();
      mc.error("There was an error while fetching your data");
    });
  };

  const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, values) => {
    return (
      <>
        {index !== 0 ?
          <AddButton onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction(array.filter((v, i) => i !== index));
            setRemovedRiskQuestionnaire([
              ...removedRiskQuestionnaire,
              ...questions.map(question => ({ idQuestionnaireAnswers: question.idQuestionnaireAnswers })).filter(questions => questions && questions.idQuestionnaireAnswers)
            ])
          }}>
            <Icon name="trash" />
          </AddButton> : <></>}
        {index === array.length - 1 ?
          <AddButton onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction([...array, removeAnswersDuplicateSession(questions, index, partySectionName, values)]);
          }}>
            <Icon name="plus" />
          </AddButton> : <></>}
      </>
    )
  }

  const renderUploadButton = (values, options) => {
    return (operation?.idDomain === 254 || operation?.idDomain === 624) ? <></> : <DragZoneUpload multiple={true}
      options={options}
      documentTypeRequired={true}
      documentType={values.documentType}
      idOperation={operation?.idOperation}
      isDraft={!operation?.idOperation}
      onSuccess={(uploadedFiles) => setAttachments([...attachments, ...uploadedFiles])} />
  }

  const requestPermissionToSubmit = async () => {
    const response = await fitinsur
      .requestAccess("", "CREATE", Access.CREATE_FRAMEWORK, null, null, authContext.token)
      .then((response) => response.json())

    const hasPermission = response && response.ret_code === 200;
    setHasPermissionCreateFramework(hasPermission);
  }

  const getLastOperationQuestionnaireId = () => {
    if (location.search) {
      const query = new URLSearchParams(location.search);
      if (query.get('refOperation')) refOperation = query.get('refOperation');
    }
  }

  const handleOperationInfo = async () => {
    if (refOperation || props.match.params.idOperation) {
      fitinsur.setAuthToken(authContext.token);
      fitinsur.requestOperationInfo(refOperation || props.match.params.idOperation)
        .then(response => response.json())
        .then(data => {
          if (data.isBound && !createWithReference) {
            isBound = data.isBound;
            setIsBoundState(data.isBound)
          }
        })
    }
  }

  const handleHighlyConfidencialDeal = async (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    if (question?.idQuestion === 110) {
      if (answer.dsAnswerOption === 'YES') {
        filteredQuestionnaire = filteredQuestionnaire.map(question => {
          if (question.idQuestion === 2001) {
            return {
              ...question,
              visibleQuestion: 1,
              behaviorObject: {
                ...question.behaviorObject,
                isRequired: true
              },
            }
          }

          return {
            ...question
          }
        });

        const filteredQuestionnaireUpdated = [
          ...filteredQuestionnaire
        ]
        filteredQuestionnaireUpdated.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);
        setFilteredQuestionnaire(filteredQuestionnaireUpdated)
        setBrokingQuestionnaire(filteredQuestionnaireUpdated)
      } else if (answer.dsAnswerOption === 'NO') {

        filteredQuestionnaire = filteredQuestionnaire.map(question => {
          if (question.idQuestion === 2001) {
            return {
              ...question,
              visibleQuestion: 1,
              behaviorObject: {
                ...question.behaviorObject,
                isRequired: false
              },
            }
          }

          return {
            ...question
          }
        });
        setFilteredQuestionnaire(filteredQuestionnaire)
        setBrokingQuestionnaire(filteredQuestionnaire)
      }
    }

    if (question?.idQuestion === 1882 && answer.length === 7) {   
      const currentDate = new Date();       
      const expiredYear = currentDate.getFullYear() + 20;
      const expiredMonth = currentDate.getMonth() + 1;
      const year = parseInt(answer.split("/").at(1));
      const month = parseInt(answer.split("/").at(0))

      if(expiredYear < year) {
        mc.error(`Please provide a valid date. Limit ${String(expiredMonth).padStart(2, '0')}/${expiredYear}.`);
        answer = answer.split("/").at() + '/';
        return;
      }
      if(expiredYear === year && expiredMonth < month) {
        mc.error(`Please provide a valid date. Limit ${String(expiredMonth).padStart(2, '0')}/${expiredYear}.`);
        answer = answer.split("/").at() + '/';
        return;
      }
    }
  }

  useEffect(() => {
    const checkIsMasterPolicy = props?.match?.params?.idProduct == 16 && !props.match?.params?.idOperationParent;
    getLastOperationQuestionnaireId();
    setIsMasterPolicy(checkIsMasterPolicy)
    getQuoteQuestionnaire(checkIsMasterPolicy);
    permissionEdit();
    requestPermissionToSubmit();
  }, []);


  const [obligor, setObligor] = useState();
  const [guarantor, setGuarantor] = useState();

  useEffect(() => {
    try {
      const newObligor = formikRef.current?.values?.$ANSWERS_OBLIGOR_0?.[0]?.answer
      if (operation && operation?.idDomain == 26 && props?.match?.params?.idProduct == 12 && newObligor) {
        setObligor(JSON.parse(newObligor))
      }
    } catch (err) {
    }
  }, [formikRef.current?.values?.$ANSWERS_OBLIGOR_0?.[0]?.answer, operation])


  return (
    <Layout
      idOperation={props.match.params.idOperation}
      title={obligor?.projectName || obligor?.namePerson || obligor?.personName || operationMap[props.match.params.idProduct]?.title || "Enquiry"}
      subtitle={operation?.metadata?.rootOperationReferenceNumber ? `${operation?.metadata?.rootOperationReferenceNumber}/${operation?.metadata?.referenceNumber}` : operation?.metadata?.referenceNumber}
    >
      <ModalEditConfirmation
        idOperation={operation?.idOperation}
        show={modalEditConfirmationDialogOpen}
        setDialog={setModalEditConfirmationDialogOpen}
        history={history}
      />

      <ModalLost
        idOperation={operation?.idOperation}
        show={modalLostDialogOpen}
        setDialog={setModalLostDialogOpen}
        history={history}
      />

      <ModalCancelEndorsement
        idOperation={operation?.idOperation}
        show={modalCancelEndorsementOpen.visible}
        setDialog={setModalCancelEndorsementOpen}
        history={history}
      />

      <StepNavigation stage={1} idOperation={props.match?.params?.idOperation} />

      {operation?.idOperation && (
        <div>
          <NotesAccordion
            title="Notes"
            idOperation={operation?.idOperation}
          />
        </div>
      )}

      <ContentCard title="Summary" icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <Formik
          innerRef={formikRef}
          initialValues={{}}
          validationSchema={buildValidation()}
          enableReinitialize={true}
          onSubmit={values => handleSaveEnquiry(values)}
          render={({ values, setFieldValue }) => (
            <Form>
              <FormSection sectionName="SUMMARY"
                questionnaire={questionnaire}
                values={values}
                setFieldValue={setFieldValue}
                formikRef={formikRef}
                externalFormCurrentClient={currentClient}
                onCurrentClientChange={currentClient => setCurrentClient(currentClient)}
                idOperationParent={props.match?.params?.idOperationParent}
                idProduct={props.match.params.idProduct}
                onRiskQuestionnaire={riskQuestionnaire}
              />

              <FormContainer hide={isClient} title="BROKING AND ACCOUNT INFORMATION">
                <FormSection
                  isToggleActived={setToggleIsActived}
                  changeStateOfToggle={changeStateDefaultOfToggle}
                  sectionName="BROKING"
                  questionnaire={questionnaire}
                  values={values}
                  setFieldValue={setFieldValue}
                  formikRef={formikRef}
                  idProduct={props.match.params.idProduct}
                  externalFormCurrentClient={currentClient}
                  onCurrentClientChange={currentClient => setCurrentClient(currentClient)}
                  onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                    handleHighlyConfidencialDeal(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                  }}
                  uxecuteInTheBeginning={(filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                    const highlyConfidencialQuestion = filteredQuestionnaire.find(question => question?.idQuestion === 110);
                    const highlyConfidencialQuestionAnswer = {
                      dsAnswerOption: highlyConfidencialQuestion?.answer
                    }

                    handleHighlyConfidencialDeal(highlyConfidencialQuestion, highlyConfidencialQuestionAnswer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);

                    const projectNameQuestion = questionnaire.find(question => question.idQuestion === 2001);
                    if (props.match.params.idOperation && projectNameQuestion) {
                      setFieldValue && setFieldValue(projectNameQuestion?.key, projectNameQuestion?.answer || '')
                    }
                  }}
                />
              </FormContainer>

              <FormContainer show={true} hide={isMasterPolicy} title="MAIN PARTY">
                {obligors.map((questions, index) => (
                  <>
                    <FormSection
                      sectionName="OBLIGOR"
                      questionnaire={questions}
                      values={values}
                      setFieldValue={setFieldValue}
                      formikRef={formikRef}
                      sectionIndex={index}
                      extraButtons={() => renderAddAndRemoveButtons(obligors, index, questions, setObligors, "$ANSWERS_OBLIGOR_0", values)}
                      onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                        if (question.idQuestion === 63) getSicCodeFromObligor(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                      }}
                      hasPermission={permissionAccess}
                      idOperation={props.match?.params?.idOperation}
                      partiesIndex={index + 1}
                    />
                  </>))}
              </FormContainer>

              <FormContainer show={true} hide={isMasterPolicy} title="Additional Party Group 1">
                {guarantors.map((questions, index) => (
                  <>
                    <FormSection
                      sectionName="GUARANTOR"
                      questionnaire={questions}
                      values={values}
                      setFieldValue={setFieldValue}
                      formikRef={formikRef}
                      sectionIndex={index}
                      extraButtons={() => renderAddAndRemoveButtons(guarantors, index, questions, setGuarantors, "$ANSWERS_GUARANTOR_0", values)}
                      onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                        if (question.idQuestion === 66) getSicCodeFromObligor(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                      }}
                      hasPermission={permissionAccess}
                      idOperation={props.match?.params?.idOperation}
                      partiesIndex={obligors.length + index + 1}
                    />
                  </>))}
              </FormContainer>

              <FormContainer show={true} hide={isMasterPolicy} title="Additional Party Group 2">
                {borrowers.map((questions, index) => (
                  <>
                    <FormSection
                      sectionName="BORROWER"
                      questionnaire={questions}
                      values={values}
                      setFieldValue={setFieldValue}
                      formikRef={formikRef}
                      sectionIndex={index}
                      extraButtons={() => renderAddAndRemoveButtons(borrowers, index, questions, setBorrowers, "$ANSWERS_BORROWER_0", values)}
                      onQuestionChange={(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
                        if (question.idQuestion === 120) getSicCodeFromObligor(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                      }}
                      hasPermission={permissionAccess}
                      idOperation={props.match?.params?.idOperation}
                      partiesIndex={obligors.length + guarantors.length + index + 1}
                    />
                  </>))}
              </FormContainer> 
              {riskQuestionnaire.map((questions, index) => (
                <FormContainer show={true} hide={isMasterPolicy} title={index === 0 ? "MAIN CONTRACT" : `FACILITY ${index}`}>
                  <FormSection
                    sectionName="FACILITY"
                    questionnaire={questions}
                    values={values}
                    setFieldValue={setFieldValue}
                    formikRef={formikRef}
                    externalFormCurrentClient={currentClient}
                    onCurrentClientChange={currentClient => setCurrentClient(currentClient)}
                    sectionIndex={index}
                    idProduct={props.match?.params?.idProduct}
                  />
                  {renderAddAndRemoveButtons(riskQuestionnaire, index, questions, setRiskQuestionnaire, true)}
                </FormContainer>)
              )}

              <FormContainer show={true} title={"ATTACHMENTS"}>
                <FormSection
                  sectionName="ATTACHMENT"
                  questionnaire={questionnaire}
                  values={values}
                  setFieldValue={setFieldValue}
                  formikRef={formikRef}
                  externalFormCurrentClient={currentClient}
                  renderUploadButton={(options) => renderUploadButton(values, options)}
                  renderAttachments={() => <TagsList
                    disabled={false ? true : false}
                    tags={attachments}
                    removeTag={(currentAttachment) => setAttachments(attachments.filter(attachment => attachments.indexOf(attachment) !== currentAttachment))}
                  />}
                />
              </FormContainer>

              {!operation?.idOperation && (
                <FormSection
                  sectionName="ATTACHMENT_NOTES"
                  questionnaire={questionnaire}
                  values={values}
                  setFieldValue={setFieldValue}
                  formikRef={formikRef}
                  externalFormCurrentClient={currentClient}
                />
              )}
              <ButtonContainer>
                <Button forth onClick={() => handleBack()}> &lt; Back</Button>
                <HasPermission permission={!isBoundState}>
                  <ButtonContent>
                    {operation?.idOperation && <Button
                      id="btnLost"
                      style={{ marginLeft: 15 }}
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); (operation.idDomain === 254 || operation.idDomain === 624 || operation.idDomain === 410) ? setModalCancelEndorsementOpen({ visible: true }) : setModalLostDialogOpen(true) }}
                      disabled={getQuestionIsDisabled({}, operation)}
                      secundary
                    >
                      {operationMap[props.match.params.idProduct]?.voidButtonTitle || "Lost"}
                    </Button>}
                    {(isClient && (operation?.idDomainDocument || operation?.idDomainStatus === 10)) ? <></> : (
                      <Button
                        id="btnSave"
                        type="submit"
                        style={{ marginLeft: 15 }}
                        // @ts-ignore
                        onClick={() => {
                          buildValidation().validate(values).catch((e) => {
                            mc.error('Please complete all required fields to proceed.')
                          })
                        }}
                        disabled={!isClient ? getQuestionIsDisabled({}, operation) : disableButton(operation)}
                        third={operation?.idDomain !== 254 && operation?.idDomain !== 624 && operation?.idOperation}
                        primary={operation?.idDomain === 254 || operation?.idDomain === 624 || !operation?.idOperation}
                      >
                        {operation?.idOperation && operation?.idDomain !== 254 && operation?.idDomain !== 624 ? "Save" : "Submit"}
                      </Button>
                    )}

                    {!isClient && (
                      !isMasterPolicy && operation?.idDomainStatus === 10 ? <Button
                        style={{ marginLeft: 15 }}
                        onClick={() => handleGenerateNbiForm()}
                        disabled={!isClient ? getQuestionIsDisabled({}, operation) : disableButton(operation)}
                        primary
                      >
                        NBI FORM
                      </Button> : <></>
                    )}
                  </ButtonContent>
                </HasPermission>
              </ButtonContainer>
            </Form>
          )}
        >
        </Formik>
        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ContentCard>
    </Layout >
  )
}
